import { type FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { UiButton, UiHStack, UiIconPlusCircle, UiStack, uiStyles, UiTag, UiText } from '@/lib/ui';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { type account } from '@/api';
import InvokeConfirmation from './InvokeConfirmation';

dayjs.extend(utc);

export interface InvokeProps {
  adminUser: account.SearchAdminUsersResponseAdminUser
}

const Invoke: FC<InvokeProps> = ({
  adminUser,
}) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <UiButton variant={'ghost'} py={0} onClick={onToggle}>Invoke</UiButton>
      <InvokeConfirmation
        isOpen={isOpen}
        onClose={onToggle}
        adminUser={adminUser}
      />
    </>
  );
};

export default Invoke;
